import React, { useRef, useState, useEffect } from 'react'
import classNames from 'classnames'
import { caculateBoxList } from '../../../../../component/imageDetail/common'
import styles from './index.module.less'

export default ({ currentImage, boxIndex, setBoxIndex, originImage }) => {
  const [boxListCopy, setBoxListCopy] = useState<Array<any>>()
  const isMounted = useRef(null)

  useEffect(() => {
    setBoxListCopy(caculateBoxList(currentImage, originImage))
    if (!isMounted.current) { isMounted.current = true; return }
    setBoxIndex(0)
  }, [currentImage, originImage])

  if (!boxListCopy) return <div />
  return (<div className={styles['meinian-image-detail-box-wrapper']}>
    {boxListCopy.map((item, index) => (
      <div
        key={index}
        onClick={(e) => { e.stopPropagation(); setBoxIndex(index) }}
        className={classNames('meinian-image-detail-box-wrapper-content', { active: boxIndex === index })}
        style={{ top: `${item.yPosition * 100}%`, left: `${item.xPosition * 100}%`, display: item.ifHide ? 'none' : 'block' }}
      >
        <div className="animation">
          <div className="inner" />
        </div>
        <div className={`line ${!item.pointRight && 'left'}`} style={item.lineStyle}>
          <div className="tag" style={item.tagStyle}>{item.category || item.rootCategory}</div>
        </div>
      </div>
    ))}
  </div>)
}
